import { THEME } from '@/theme';
import * as React from 'react';

const defaultSize = 24;

// Monochrome outline "i" — the section-label counterpart to InfoCircleIcon (a solid blue badge,
// which is right for notifications but reads as an alert next to the grey Documentation/Dataset
// glyphs used on the same labels). Same 24 viewBox and 2px stroke as the other outline icons.
export default ({
  height = defaultSize,
  width = defaultSize,
  color = THEME.colors.defaultGray,
}: {
  height?: number | string;
  width?: number | string;
  color?: string;
}) => (
  <svg
    height={height}
    width={width}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
  >
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2" />
    <path d="M12 11v5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    {/* A round-capped zero-length stroke, so the dot is exactly as thick as every other mark
        rather than a slightly heavier filled disc. */}
    <path d="M12 7.5h0.01" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);
